export const paymentTypes = [
  "usio",
  "usio_pickup",
  "usio_virtual",
  "usio_mail",
  "ach",
  "wu",
  "debit",
  "givecard_mail",
  "givecard_load",
  "givecard_virtual",
  "givecard_rtp",
  "usbank_card_mail",
  "usbank_card_load",
  "usbank_card_withdrawal",
  "usbank_zelle",
] as const;

export type PaymentType = typeof paymentTypes[number];

export const isValidPaymentType = (type: string): type is PaymentType => {
  return paymentTypes.includes(type as PaymentType);
};

// Surface the intermediate SENDING / VENDOR_RECV vendor hand-off action states as PENDING, so
// the badge, filters, grouping, and exports don't expose the internal stage to staff.
export function normalizeDisplayStatus(status: string): string {
  return status === 'VENDOR_RECV' || status === 'SENDING' ? 'PENDING' : status;
}
